export const listMutations = <const>{
	SKLAD_NAKLADOVE_STREDISKO_SELECT_MAPPER: 'SKLAD_NAKLADOVE_STREDISKO_SELECT_MAPPER',
	PRACOVNIK_SELECT_MAPPER: 'PRACOVNIK_SELECT_MAPPER',
	SET_PACKET_DETAIL: 'SET_PACKET_DETAIL',
};

export const listActions = <const>{
	UPDATE_FILTER: 'updateFilter',
	FETCH_PACKET_DETAIL: 'fetchPacketDetail',
	PREPOCET_CENY: 'prepocetCeny',
	ODEPIS_PP: 'odepisPp',
	ODEPIS_ND: 'odepisNd',
	DELETE_PACKET: 'deletePacket',
	FILTER_INIT: 'filterInit',
	ROZPAD_PACKETU: 'rozpadPacketu',
};
